import * as React from 'react';
import * as b_ from 'b_';
import cn from 'classnames';

import './index.scss';

interface Props extends React.SVGAttributes<SVGElement> {}

const b = b_.with('icon-whatsapp');

export const EmailIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg className={cn(b(), className)} viewBox="0 0 25 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.75 0.6875H2.625C1.31016 0.6875 0.246328 1.76328 0.246328 3.07812L0.234375 17.4219C0.234375 18.7367 1.31016 19.8125 2.625 19.8125H21.75C23.0648 19.8125 24.1406 18.7367 24.1406 17.4219V3.07812C24.1406 1.76328 23.0648 0.6875 21.75 0.6875ZM21.75 5.46875L12.1875 11.4453L2.625 5.46875V3.07812L12.1875 9.05469L21.75 3.07812V5.46875Z" />
    </svg>
  );
};
